(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-products"] && !Shopify.designMode) return;
  try {
    
function initializeCampaign(root) {
  if (root.dataset.campaignInitialized) return;
  root.dataset.campaignInitialized = 'true';
  const buttons = [...root.querySelectorAll('[data-campaign-filter]')];
  const cards = [...root.querySelectorAll('[data-campaign-product]')];
  const count = root.querySelector('[data-deal-count]');
  const grid = root.querySelector('[data-deal-grid]');
  const filterToggle = root.querySelector('[data-deal-filter-toggle]');
  filterToggle?.addEventListener('click', () => {
    const expanded = filterToggle.getAttribute('aria-expanded') !== 'true';
    filterToggle.setAttribute('aria-expanded', String(expanded));
    root.querySelector('.deal-catalog > .store-filter-tabs')?.classList.toggle('is-collapsed', !expanded);
  });
  const updateCount = () => {
    const visibleCount = cards.filter((card) => !card.hidden).length;
    if (count) count.textContent = String(visibleCount);
    const empty = root.querySelector('[data-deal-empty]');
    if (empty) empty.hidden = visibleCount !== 0;
  };
  buttons.forEach((button) => button.addEventListener('click', () => {
    const category = button.dataset.campaignFilter;
    buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    cards.forEach((card) => {
      const matchesPrice = category === 'price-under-50' && Number(card.dataset.productPrice) < 5000;
      const matchesDiscount = category === 'discount-15' && Number(card.dataset.productDiscount) >= 15;
      const matchesCategory = card.dataset.productCategory === category;
      card.hidden = category !== 'all' && !matchesPrice && !matchesDiscount && !matchesCategory;
    });
    updateCount();
  }));
  root.querySelector('[data-deal-reset]')?.addEventListener('click', () => {
    const all = buttons.find((button) => button.dataset.campaignFilter === 'all');
    all?.click();
    all?.focus();
  });
  const sort = root.querySelector('[data-deal-sort]');
  sort?.addEventListener('change', () => {
    if (!grid) return;
    const direction = sort.value === 'price-high' ? -1 : 1;
    const sorted = [...cards].sort((a, b) => {
      if (sort.value === 'saving') return Number(b.dataset.productDiscount) - Number(a.dataset.productDiscount);
      if (sort.value === 'price-low' || sort.value === 'price-high') return (Number(a.dataset.productPrice) - Number(b.dataset.productPrice)) * direction;
      return Number(a.dataset.productOrder) - Number(b.dataset.productOrder);
    });
    sorted.forEach((card) => grid.append(card));
  });
  const countdown = root.querySelector('[data-deal-countdown]');
  if (countdown) {
    const parseTime = (value) => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value || '') ? Date.parse(value) : NaN;
    const endTime = parseTime(countdown.dataset.countdownEnd);
    const startValue = countdown.dataset.countdownStart;
    const startTime = startValue ? parseTime(startValue) : -Infinity;
    const valid = Number.isFinite(endTime) && (!startValue || Number.isFinite(startTime)) && startTime < endTime;
    const callout = countdown.closest('.store-deal-callout');
    const heading = callout.querySelector('[data-offer-heading]');
    const detail = callout.querySelector('[data-offer-text]');
    const date = callout.querySelector('[data-countdown-date]');
    const activeHeading = heading.textContent;
    const activeDetail = detail.textContent;
    // Keep the displayed schedule aligned with the merchant's configured Beijing time,
    // regardless of the visitor's device timezone.
    const formatDate = (time) => new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Shanghai', timeZoneName: 'short' }).format(time);
    const fields = { days: countdown.querySelector('[data-countdown-days]'), hours: countdown.querySelector('[data-countdown-hours]'), minutes: countdown.querySelector('[data-countdown-minutes]'), seconds: countdown.querySelector('[data-countdown-seconds]') };
    let timer;
    const updateCountdown = () => {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      const remaining = endTime - Date.now();
      const upcoming = valid && Date.now() < startTime;
      if (!valid || remaining <= 0 || upcoming) {
        countdown.hidden = true;
        callout?.classList.remove('has-countdown');
        heading.textContent = upcoming ? countdown.dataset.upcomingLabel : (valid ? countdown.dataset.endedLabel : '');
        detail.textContent = upcoming ? formatDate(startTime) : '';
        if (date) date.textContent = upcoming ? `Starts ${formatDate(startTime)}` : '';
        callout.hidden = !valid;
        if (!valid || remaining <= 0) window.clearInterval(timer);
        return;
      }
      callout.hidden = false;
      heading.textContent = remaining <= 86400000 ? 'Final 24 hours' : activeHeading;
      detail.textContent = activeDetail;
      if (date) date.textContent = `Ends ${formatDate(endTime)}`;
      countdown.hidden = false;
      callout?.classList.add('has-countdown');
      const totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      fields.hours.textContent = String(Math.floor(totalSeconds % 86400 / 3600)).padStart(2, '0');
      fields.minutes.textContent = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
      fields.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
    };
    updateCountdown();
    if (valid && endTime > Date.now()) timer = window.setInterval(updateCountdown, 1000);
  }
}
document.querySelectorAll('[data-campaign-root]').forEach(initializeCampaign);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-campaign-root]').forEach(initializeCampaign));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-entry"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gift-card-root]').forEach((root) => {
  const input = root.querySelector('[data-gift-card-variant]');
  const price = root.querySelector('[data-gift-card-price]');
  root.querySelectorAll('[data-gift-variant-id]').forEach((button) => button.addEventListener('click', () => {
    input.value = button.dataset.giftVariantId;
    price.textContent = button.dataset.giftVariantPrice;
    root.querySelectorAll('[data-gift-variant-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-product-recommendations][data-url]').forEach((section) => {
  const mount = (target) => {
    const rail = document.querySelector('[data-product-root] [data-product-recommendation-mount]');
    if (!rail) return;
    rail.append(target);
    target.hidden = false;
  };
  mount(section);
  fetch(section.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement && replacement.querySelector('.product-cross-sell__item')) {
        section.replaceWith(replacement);
        mount(replacement);
      }
    })
    .catch(() => {});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-related-recommendations][data-url]').forEach((section) => {
  fetch(section.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const replacement = parsed.querySelector('[data-related-recommendations]');
      if (replacement && replacement.querySelector('.product-card')) section.replaceWith(replacement);
    })
    .catch(() => {});
});

  } catch(e) { console.error(e); }
})();
})();
